// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.

import { DefaultButton, IBaseButtonProps, PrimaryButton, useTheme } from '@fluentui/react';
import { joinCallActiveButtonStyles, joinCallButtonStyles } from './CallDetailsCard.styles';
import React from 'react';
import { StyledSpinner } from './StyledSpinner';

export type JoinCallIdentityKind = 'acs' | 'teams';

export const JoinCallButton = (props: {
  primary?: boolean;
  disabled?: boolean;
  visuallyDisabled?: boolean;
  onJoinClick: (identityType: JoinCallIdentityKind) => Promise<void>;
  text?: string;
  iconName?: string;
  spinnerAriaLabel?: string;
}): JSX.Element => {
  const text = props.text ?? 'Join call';
  const iconName = props.iconName ?? 'CallCardCamera';
  const spinnerAriaLabel = props.spinnerAriaLabel ?? 'Joining...';

  const theme = useTheme();
  // const cteUsageEnabled = useExperiments().experimentValues.CTE.activeValue;

  // `onClickActive` is the time when the button is clicked, until the onClick callback completes.
  // During this we show the button text as a spinner.
  const [onClickActive, setOnClickActive] = React.useState(false);

  const click = async (joinType: JoinCallIdentityKind): Promise<void> => {
    if (onClickActive) {
      return;
    }

    // Set spinner to show while joining call
    setOnClickActive(true);
    try {
      await props.onJoinClick(joinType);
    } finally {
      // Clear spinner now onJoinCall has completed
      setOnClickActive(false);
    }
  };

  const commonButtonProps: IBaseButtonProps = {
    // menuProps: !cteUsageEnabled
    //   ? undefined
    //   : {
    //       items: [
    //         {
    //           key: 'joinACS',
    //           text: 'Join using ACS Idenitity',
    //           secondaryText:
    //             'Join the Call using an anonymous ACS Idenitity with your name. You will have access to Chat but will need to be admitted by the meeting organizer.',
    //           onClick: () => {
    //             click('acs');
    //           },
    //           iconProps: { iconName: 'AcsLogo' },
    //           onRenderContent: renderJoinMenuItem
    //         },
    //         {
    //           key: 'joinTeams',
    //           text: 'Join using Teams Idenitity',
    //           secondaryText:
    //             'Join the Call using your M365 Idenitity. You will not have access to Chat as ACS does not support Teams Chat Interop.',
    //           onClick: () => {
    //             click('teams');
    //           },
    //           iconProps: { iconName: 'TeamsLogoSmall' },
    //           onRenderContent: renderJoinMenuItem
    //         }
    //       ]
    //     },
    menuProps: undefined, // Always set to undefined instead of checking cteUsageEnabled
    disabled: props.disabled,
    iconProps: { iconName },
    onClick: () => click('acs')
  };

  const buttonContent = onClickActive ? <StyledSpinner ariaLabel={spinnerAriaLabel} /> : text;

  return props.primary ? (
    <PrimaryButton {...commonButtonProps} styles={joinCallActiveButtonStyles}>
      {buttonContent}
    </PrimaryButton>
  ) : (
    <DefaultButton {...commonButtonProps} styles={joinCallButtonStyles(theme, !!props.visuallyDisabled)}>
      {buttonContent}
    </DefaultButton>
  );
};

// const renderJoinMenuItem = (
//   props: IContextualMenuItemProps,
//   defaultRenders: IContextualMenuItemRenderFunctions
// ): React.ReactNode => {
//   return (
//     <TooltipHost content={props.item.secondaryText} calloutProps={{ gapSpace: 0 }} delay={0}>
//       <Stack horizontal tokens={{ childrenGap: '0rem' }}>
//         <Stack.Item
//           styles={{
//             root: {
//               display: 'flex',
//               alignItems: 'center',
//               justifyContent: 'center'
//             }
//           }}
//         >
//           {defaultRenders.renderItemIcon(props)}
//         </Stack.Item>
//         {defaultRenders.renderItemName(props)}
//       </Stack>
//     </TooltipHost>
//   );
// };
